module.exports = __webpack_public_path__ + "img/Icons-04.418cd55a.svg";